export default __webpack_public_path__ + "static/media/eb-pro-wht-poster-2.35f46107.jpg";